import { Input, Label } from "reactstrap";

const FilterJenisPembayaran = ({ setSelectedFilterJenisPembayaran }) => {
  return (
    <>
      <Label>Jenis Pembayaran</Label>
      <Input
        type="select"
        onChange={(e) => setSelectedFilterJenisPembayaran(e.target.value)}
      >
        <option value={""}>Semua</option>
        <option key={"UMO"} value={"UMO"}>
          UMO
        </option>
        <option key={"LS"} value={"LS"}>
          LS
        </option>
      </Input>
    </>
  );
};

export default FilterJenisPembayaran;
